import animationData from '../screenassets/lottiefiles/No-Data.json';
import Lottie from "lottie-react";

function NoData() {
    return (
        <div className='d-flex justify-content-center align-items-center'>
            <div style={{ height: '200px', width: '200px' }}>
                <Lottie animationData={animationData} loop={true} />
            </div>
        </div>
    )
}

export default NoData
